import { useState } from "react";

/**
 * Runs a callback once when a condition becomes true.
 * Prevents re-running even if the condition stays true or toggles.
 */
export function useRunOnceWhen(condition: boolean, callback: () => void) {
  const [hasRun, setHasRun] = useState(false);

  if (condition && !hasRun) {
    setHasRun(true);
    callback();
  }
}
